import {organizationSettingsConstants, proactiveConstants} from '_constants';

const INITIAL_STATE = {
    handleInfo: {},
    loadingHandleInfo: false,
    handleInfoError: false,

    trendsHandles: [],
    loadingTrendsHandles: false,
    trendsHandlesError: false,

    autoActionsInfo: {},
    loadingAutoActionsInfo: false,
    handleAutoActionsInfoError: false,

    organizationInfo: {},
    loadingOrganizationInfo: false,
    organizationInfoError: false,

    trendsOrganization: {},
    loadingTrendsOrganization: false,
    trendsOrganizationError: false,
    updatingTrendsOrganizationField: null,

    organizationCSMs: [],
    loadingOrganizationCSMs: false,
    organizationCSMsError: false,

    disableProcesses: {},
    loadingDisableProcesses: false,
    disableProcessesError: false,

    removeProcesses: {},
    loadingRemoveProcesses: false,
    removeProcessesError: false,

    ticketBudgetUpdate: {},
    updatingBilling: '',
    loadingTicketBudgetUpdate: false,
    ticketBudgetUpdateError: '',

    organizationAttributeUpdate: {},
    loadingOrganizationAttributeUpdate: false,
    organizationAttributeUpdateError: '',
    payloadRef: {},

    msgSources: {},
    loadingMsgSources: false,
    msgSourcesError: '',
};

export function organizationSettingsReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case organizationSettingsConstants.GET_ORGANIZATION_INFO_REQUEST:
            return {...state, loadingOrganizationInfo: true, organizationInfoError: ''};
        case organizationSettingsConstants.GET_ORGANIZATION_INFO_SUCCESS:
            return {...state, organizationInfo: action.payload, loadingOrganizationInfo: false};
        case organizationSettingsConstants.GET_ORGANIZATION_INFO_FAILURE:
            return {...state, organizationInfoError: action.error, loadingOrganizationInfo: false};

        case organizationSettingsConstants.GET_TRENDS_ORGANIZATION_REQUEST:
            return {...state, loadingTrendsOrganization: true, trendsOrganizationError: false, trendsOrganization: {}};
        case organizationSettingsConstants.GET_TRENDS_ORGANIZATION_SUCCESS:
            return {...state, trendsOrganization: action.payload, loadingTrendsOrganization: false};
        case organizationSettingsConstants.GET_TRENDS_ORGANIZATION_FAILURE:
            return {...state, trendsOrganizationError: action.error, loadingTrendsOrganization: false};

        case organizationSettingsConstants.UPDATE_TRENDS_ORGANIZATION_SETTING_REQUEST:
            return {...state, updatingTrendsOrganizationField: action.payload?.field, trendsOrganizationError: false};
        case organizationSettingsConstants.UPDATE_TRENDS_ORGANIZATION_SETTING_SUCCESS:
            return {
                ...state,
                trendsOrganization: {...state.trendsOrganization, ...action.payload},
                updatingTrendsOrganizationField: null,
            };
        case organizationSettingsConstants.UPDATE_TRENDS_ORGANIZATION_SETTING_FAILURE:
            return {...state, trendsOrganizationError: action.error, updatingTrendsOrganizationField: null};

        case organizationSettingsConstants.UPDATE_TICKET_BUDGET_REQUEST:
            return {...state, loadingTicketBudgetUpdate: true, ticketBudgetUpdateError: '', updatingBilling: action.payload};
        case organizationSettingsConstants.UPDATE_TICKET_BUDGET_SUCCESS:
            return {...state, ticketBudgetUpdate: action.payload, loadingTicketBudgetUpdate: false};
        case organizationSettingsConstants.UPDATE_TICKET_BUDGET_FAILURE:
            return {...state, ticketBudgetUpdateError: action.error, loadingTicketBudgetUpdate: false};

        case organizationSettingsConstants.UPDATE_ORGANIZATION_ATTRIBUTE_REQUEST:
            return {...state, loadingOrganizationAttributeUpdate: true, organizationAttributeUpdateError: '', payloadRef: action.payload};
        case organizationSettingsConstants.UPDATE_ORGANIZATION_ATTRIBUTE_SUCCESS:
            return {...state, organizationAttributeUpdate: action.payload, loadingOrganizationAttributeUpdate: false};
        case organizationSettingsConstants.UPDATE_ORGANIZATION_ATTRIBUTE_FAILURE:
            return {...state, organizationAttributeUpdateError: action.error, loadingOrganizationAttributeUpdate: false};

        case organizationSettingsConstants.GET_ORGANIZATION_CSM_LIST_REQUEST:
            return {...state, loadingOrganizationCSMs: true, organizationCSMsError: ''};
        case organizationSettingsConstants.GET_ORGANIZATION_CSM_LIST_SUCCESS:
            return {...state, organizationCSMs: action.payload, loadingOrganizationCSMs: false};
        case organizationSettingsConstants.GET_ORGANIZATION_CSM_LIST_FAILURE:
            return {...state, organizationCSMsError: action.error, loadingOrganizationCSMs: false};

        case organizationSettingsConstants.GET_DATA_SOURCE_HANDLE_INFO_FETCH_REQUEST:
            return {...state, loadingHandleInfo: true, handleInfoError: ''};
        case organizationSettingsConstants.GET_DATA_SOURCE_HANDLE_INFO_REFRESH_REQUEST:
            return {...state, loadingHandleInfo: false, handleInfoError: ''};
        case organizationSettingsConstants.GET_DATA_SOURCE_HANDLE_INFO_SUCCESS:
            return {...state, handleInfo: action.payload, loadingHandleInfo: false};
        case organizationSettingsConstants.GET_DATA_SOURCE_HANDLE_INFO_FAILURE:
            return {...state, handleInfoError: action.error, loadingHandleInfo: false};

        case organizationSettingsConstants.GET_TRENDS_DATA_SOURCE_HANDLES_REQUEST:
            return {...state, loadingTrendsHandles: true, trendsHandles: [], trendsHandlesError: ''};
        case organizationSettingsConstants.GET_TRENDS_DATA_SOURCE_HANDLES_SUCCESS:
            return {...state, trendsHandles: action.payload || [], loadingTrendsHandles: false};
        case organizationSettingsConstants.GET_TRENDS_DATA_SOURCE_HANDLES_FAILURE:
            return {...state, trendsHandlesError: action.error, loadingTrendsHandles: false};

        case organizationSettingsConstants.GET_AUTO_ACTIONS_INFO_FETCH_REQUEST:
            return {...state, loadingAutoActionsInfo: true, handleAutoActionsInfoError: ''};
        case organizationSettingsConstants.GET_AUTO_ACTIONS_INFO_REFRESH_REQUEST:
            return {...state, loadingAutoActionsInfo: false, handleAutoActionsInfoError: ''};
        case organizationSettingsConstants.GET_AUTO_ACTIONS_INFO_SUCCESS:
            return {...state, autoActionsInfo: action.payload, loadingAutoActionsInfo: false};
        case organizationSettingsConstants.GET_AUTO_ACTIONS_INFO_FAILURE:
            return {...state, handleAutoActionsInfoError: action.error, loadingAutoActionsInfo: false};

        case organizationSettingsConstants.GET_ORGANIZATION_DISABLE_PROCESSES_REQUEST:
            return {...state, loadingDisableProcesses: true, disableProcessesError: ''};
        case organizationSettingsConstants.GET_ORGANIZATION_DISABLE_PROCESSES_SUCCESS:
            return {...state, disableProcesses: action.payload, loadingDisableProcesses: false};
        case organizationSettingsConstants.GET_ORGANIZATION_DISABLE_PROCESSES_FAILURE:
            return {...state, disableProcessesError: action.error, loadingDisableProcesses: false};

        case organizationSettingsConstants.GET_ORGANIZATION_REMOVE_PROCESSES_REQUEST:
            return {...state, loadingRemoveProcesses: true, removeProcessesError: ''};
        case organizationSettingsConstants.GET_ORGANIZATION_REMOVE_PROCESSES_SUCCESS:
            return {...state, removeProcesses: action.payload, loadingRemoveProcesses: false};
        case organizationSettingsConstants.GET_ORGANIZATION_REMOVE_PROCESSES_FAILURE:
            return {...state, removeProcessesError: action.error, loadingRemoveProcesses: false};

        case organizationSettingsConstants.GET_MSG_DATA_SOURCES_REQUEST:
            return {...state, loadingMsgSources: true, msgSources: {}, msgSourcesError: ''};
        case organizationSettingsConstants.GET_MSG_DATA_SOURCES_SUCCESS:
            return {...state, msgSources: action.payload, loadingMsgSources: false};
        case organizationSettingsConstants.GET_MSG_DATA_SOURCES_FAILURE:
            return {...state, msgSourcesError: action.error, msgSources: {}, loadingMsgSources: false};

        default:
            return state
    }
}
